


export class CJI5 {
  "refDocumentNumber";
  "referenceItem";
  "companyCode";
  "wbsElement";
  "object";
  "objectType";
  "period";
  "vendor";
  "material";
  "materialDescription";
  "documentDate";
  "debitDate";
  "totalQuantity";
  "quantityPlan";
  "valueInObjCrcy";
  "planObjectCur";
  "fiscalYear";
  "objectCurrency";
  "coObjectName";
  "referenceDocType";
  "dtImportacao";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CJI5`.
   */
  static getModelName() {
    return "CJI5";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CJI5 for dynamic purposes.
  **/
  static factory(data) {
    return new CJI5(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'CJI5',
      plural: 'CJI5s',
      path: 'CJI5s',
      properties: {
        "refDocumentNumber": {
          name: 'refDocumentNumber',
          type: 'string'
        },
        "referenceItem": {
          name: 'referenceItem',
          type: 'string'
        },
        "companyCode": {
          name: 'companyCode',
          type: 'string'
        },
        "wbsElement": {
          name: 'wbsElement',
          type: 'string'
        },
        "object": {
          name: 'object',
          type: 'string'
        },
        "objectType": {
          name: 'objectType',
          type: 'string'
        },
        "period": {
          name: 'period',
          type: 'string'
        },
        "vendor": {
          name: 'vendor',
          type: 'string'
        },
        "material": {
          name: 'material',
          type: 'string'
        },
        "materialDescription": {
          name: 'materialDescription',
          type: 'string'
        },
        "documentDate": {
          name: 'documentDate',
          type: 'string'
        },
        "debitDate": {
          name: 'debitDate',
          type: 'string'
        },
        "totalQuantity": {
          name: 'totalQuantity',
          type: 'string'
        },
        "quantityPlan": {
          name: 'quantityPlan',
          type: 'string'
        },
        "valueInObjCrcy": {
          name: 'valueInObjCrcy',
          type: 'string'
        },
        "planObjectCur": {
          name: 'planObjectCur',
          type: 'string'
        },
        "fiscalYear": {
          name: 'fiscalYear',
          type: 'string'
        },
        "objectCurrency": {
          name: 'objectCurrency',
          type: 'string'
        },
        "coObjectName": {
          name: 'coObjectName',
          type: 'string'
        },
        "referenceDocType": {
          name: 'referenceDocType',
          type: 'string'
        },
        "dtImportacao": {
          name: 'dtImportacao',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/CJI5.js